import { useEffect, useMemo, useState } from 'react'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../base/customHooks/componentHOC'
import Table from '../../../../components/Table'
import { PreOrderListModelList } from '../models/models'
import { GetPreOrderListApi } from '../services/getPreOrderListApi'
import { CheckPreOrderAuthApi } from '../../MyOrders/services/checkPreOrderAuthApi'

function PreOrderList(props: BaseComponentWithContextProps) {


  const [list, setList] = useState<PreOrderListModelList[]>([])
  const [auth, setAuth] = useState<boolean>(false)
  const [addDealer, setAddDealer] = useState<any>()
  const [dealerFromText, addDealerText] = useState<string>("")

  useEffect(() => {
    checkAuth()
  }, [])

  useEffect(() => {
    if (auth)
      getList()
  }, [auth])

  const getList = async () => {
    props.showLoading()
    const list: GetPreOrderListApi = new GetPreOrderListApi({})

    list
      .getPreOrderList()
      .then((res: any) => {
        props.hideLoading()
        setList(res)
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading()
      })
  }

  const checkAuth = async () => {
    props.showLoading()
    const list: CheckPreOrderAuthApi = new CheckPreOrderAuthApi({})

    list
      .checkPreOrder()
      .then((res: any) => {
        props.hideLoading()
        setAuth(res)
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading()
      })
  }

  const tableColumns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'count',
      },
      {
        Header: 'Referans No',
        accessor: 'refNo',
      },
      {
        Header: 'Bayi Kodu',
        accessor: 'dealerCode',
      },
      {
        Header: 'Bayi Adı',
        accessor: 'dealerName',
      },
      {
        Header: 'Firma Adı',
        accessor: 'companyName',
      },
      {
        Header: 'Sipariş Numaraları',
        accessor: 'orderNumber',
      },
      {
        Header: 'Ön Sipariş Tarihi',
        accessor: 'createdDate',
      },
      {
        Header: 'İşlemler',
        accessor: 'edit',
      },
      {
        Header: 'Onay Durumu',
        accessor: 'approval',
      },
    ],
    []
  )

  const navigate: any = useNavigate()

  const tableData = useMemo(
    () =>
      list.map((item, index) => {
        const data = {
          count: index + 1,
          refNo: item.ReferenceNumber,
          dealerCode: item.DealerCode,
          dealerName: item.DealerName,
          companyName: item.CompanyName,
          orderNumber: item.OrderNumber,
          createdDate: new Date(item.CreatedDate).toLocaleDateString('tr-TR') + ' ' + new Date(item.CreatedDate).toLocaleTimeString('tr-TR'),
          edit: (<>
            <a
              data-action-type='edit'
              role='button'
              style={{ cursor: 'pointer', marginLeft: '20px' }}
              data-toggle='tooltip'
              data-original-title={"Düzenle"}
              onClick={() => navigate(`../myspecial/EditPreOrder?refNumber=${item.ReferenceNumber}`)}
            >
              <i className='icon-edit' style={{ fontSize: '1.2rem', color: 'green' }}></i>
            </a></>
          ),
          approval: item.DealerApproval === 0 ? (<span className='badge badge-warning'>Yönetici Onayı Bekliyor</span>) :
            item.DealerApproval === 1 ? (<span className='badge badge-success'>Onayınız Bekliyor</span>) :
              item.DealerApproval === -1 ? (<span className='badge badge-warning'>Reddedildi</span>) :
                item.DealerApproval === 2 ? (<span className='badge badge-warning'>Onaylandı</span>) :
                  item.DealerApproval === 4 ? (<span className='badge badge-success'>Kısmi Onay</span>) :
                    (<span className='badge badge-warning'>Bilinmiyor</span>)
        }
        return data
      }),
    [list]
  )


  return (
    <div className=''>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between'>
            <span className='h4'>Ön Sipariş Listesi</span>
          </div>
          <div className='card-body'>
            <div className='row'>
              <Table columns={tableColumns} data={tableData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default componentWithContext(PreOrderList)
